import { LoadSpec, Container } from "api/rest/quote-requests";
import { AccessorialType, AddressType, RoutingType, QuoteType } from "api/types/generated-types";
import { DateIsoString } from "types/DateIsoString";
import { Incoterms } from "types/Incoterms";
import { z } from "zod";

export enum QuoteStepIndex {
  Routing = 0,
  Location = 0,

  Service = 1,
  LoadAttributes = 1,

  Containers = 2,
  CargoDetails = 2,

  Shipment = 3,

  Partners = 4,

  Team = 5,

  Review = 6,

  Confirmation = 7,
}

export const addressSchema = z.object({
  id: z.number().optional(),
  name: z.string().nullable().optional(),
  address_1: z.string().nullable().optional(),
  address_2: z.string().nullable().optional(),
  city: z.string().nullable().optional(),
  zip: z.string().nullable().optional(),
  country_code: z.string().nullable().optional(),
  country_name: z.string().nullable().optional(),
  province_code: z.string().nullable().optional(),
  province_name: z.string().nullable().optional(),
  placeId: z.string().nullable().optional(),
  googlePlaceDescription: z.string().nullable().optional(),
  type: z.string().nullable().optional(),
});

type Recipient = { contactId: number; email: string; name: string };

export type BuildQuoteRequest = {
  referenceNumber?: string | null;
  deadline?: DateIsoString | null;
  hazardousGoodsDetails?: string | null;
  isHazardous?: boolean | null;
  additionalNotes?: string | null;
  carrierRoutingPrefNotes?: string | null;
  incoterms?: Incoterms | null;
  routingType?: RoutingType | null;
  cargoReadyDate?: DateIsoString | null;
  targetDeliveryDate?: DateIsoString | null;
  containers?: Container[];
  accessorials?: {
    id: string;
    name: string;
    type: AccessorialType;
  }[];
  stops?: Array<{
    start?: DateIsoString | null;
    end?: DateIsoString | null;

    isTimeTbd?: boolean;
    note?: string;
    address: {
      name?: string | null;
      address1?: string | null;
      address2?: string | null;
      city?: string | null;
      zip?: string | null;
      countryCode?: string | null;
      countryName?: string | null;
      provinceCode?: string | null;
      provinceName?: string | null;
      googlePlaceId?: string | null;
      googlePlaceDescription?: string | null;
      type?: AddressType;
    };
  }>;
  partners?: Array<Recipient>;
  teammates?: Array<Recipient>;
  reason?: string;
  bookedQuoteId?: number;
  fileIds?: string[];
  bookingNotes?: string;
  proNumber?: string;
  bolNumber?: string;
  loadSpec?: Omit<LoadSpec, "id">;
  // Quote Preferences
  quoteTypes?: QuoteType[];
  directSailingRequired?: boolean;
  capacityGuaranteeRequired?: boolean;

  insuranceRequired?: boolean;
  unloadingDetails?: string;
  note?: string;
  goodsValue?: number;
};
